import React, { useEffect, useState } from "react";
import TableActions from "../molecules/TableActions";
import axios from "axios";
import ShortlistTable from "./ShortlistTable";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";

const ShortlistPage = () => {
  const [requests, setRequests] = useState([]);
  const { jobId } = useParams();

  useEffect(() => {
    const fetchShortlisted = async () => {
      const token = localStorage.getItem("token");
      if (!token || !jobId) return;

      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/candidates/applications/decisions`,
          {
            params: { jobId, status: "shortlisted" },
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log("Shortlisted response:", res.data); // ✅ debug log
        setRequests(res.data.data || []);
      } catch (err) {
        console.error("Error fetching shortlisted:", err);
      }
    };

    fetchShortlisted();
  }, [jobId]);

  return (
    <div className="w-full h-screen p-6 bg-gray-50">
      <h2 className="mb-6 text-2xl font-MTNfont">Shortlisting</h2>

      <div className="space-y-6">
        <TableActions />
        <ShortlistTable requests={requests} />
      </div>
    </div>
  );
};

export default ShortlistPage;
